//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapState} from 'vuex'
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import FilterCheckbox from '~/components/form/user/search/FilterCheckbox'
import FilterRadio from '~/components/form/user/search/FilterRadio'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import {isObject} from '~/utils/v'
import searchUtils from '~/mixins/search/search-utils'
import SearchFiltersSkeleton from '~/components/search/search-filters-skeleton.vue'
import {SEARCH_OTHER_PAGES, SEARCH_OTHER_PAGES_FILTERS_WHITELIST} from '~/utils/search/search.constants'

export default {
  name: 'SearchFilters',
  components: { SearchFiltersSkeleton, FilterCheckbox, FilterRadio, VueSlider },
  filters: {
    fixUnder (val) {
      const text = val.replace('_', ' ').toLowerCase()
      return text.charAt(0).toUpperCase() + text.slice(1)
    }
  },
  mixins: [searchUtils],
  props: {
    only: {
      type: Array,
      default: () => []
    },
    filtersOpened: {
      type: Boolean,
      default: false
    },
    alwaysOpen: {
      type: Boolean,
      default: false
    },
    alwaysOpenFilters: {
      type: Array,
      default: () => []
    },
    defOpenFilters: {
      type: Array,
      default: () => []
    },
    isLink: {
      type: Boolean,
      default: true
    },
    noLimits: {
      type: Array,
      default: () => ['sail_type', 'boat_types']
    },
    filterFiltersFunction: {
      type: Function,
      default: i => i
    }
  },
  data () {
    return {
      request: {
        stack: [],
        loading: false,
        timer: null
      },
      filter: {
        isOpen: false,
        limit: 5
      },
      openFilters: {},

      filterKeysConfig: {
        locations: {
          title: 'locations',
          key: 'subLocations',
          type: 'checkbox',
          valueSource: 'locations',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        cabins: {
          title: 'cabins',
          key: 'cabins',
          type: 'range',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        length: {
          title: 'length-ft-',
          key: 'length',
          type: 'range',
          valueSource: 'lengths',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        years: {
          title: 'year',
          key: 'year',
          type: 'range',
          valueSource: 'year',
          classes: { container: [] }
        },
        bathrooms: {
          title: 'toilets',
          key: 'bathrooms',
          type: 'range',
          valueSource: 'bathrooms',
          classes: { container: [] }
        },
        guests: {
          title: 'guests',
          key: 'guestRange',
          type: 'range',
          valueSource: 'guestRange',
          classes: { container: [] }
        },
        prices: {
          title: 'total-price',
          key: 'price',
          type: 'subscribes',
          valueSource: 'prices',
          changeCallbackMin: 'setKeyMinValue',
          changeCallbackMax: 'setKeyMaxValue',
          classes: { container: [] }
        },
        equipments: {
          title: 'equipments',
          key: 'equipments',
          type: 'checkbox',
          valueSource: 'equipments',
          changeCallback: 'setKeyListValue',
          classes: { container: [] },
          returnField: 'id',
          withCount: false
        },
        booking_options: {
          title: 'booking-option',
          key: 'booking_options',
          type: 'radio',
          valueSource: 'booking_options',
          changeCallback: 'setKeyValue',
          removeCallback: 'removeFilter',
          classes: { container: [], input: [] }
        },
        extras: {
          title: 'extras',
          key: 'extras',
          type: 'checkbox',
          valueSource: 'extras',
          changeCallback: 'setKeyListValue',
          hasTranslation: true,
          classes: { container: [] }
        },
        charter_types: {
          title: 'charter-type',
          key: 'charter_types',
          type: 'radio',
          valueSource: 'charter_types',
          changeCallback: 'setKeyValue',
          removeCallback: 'removeFilter',
          classes: { container: [], input: [] }
        },
        boat_types: {
          title: 'boat-type',
          key: 'boat_types',
          type: 'checkbox',
          valueSource: 'boat_types',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        sail_type: {
          title: 'sail-type',
          key: 'sail_type',
          type: 'checkbox',
          valueSource: 'sail_type',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        genoa_type: {
          title: 'genoa-type',
          key: 'genoa_type',
          type: 'checkbox',
          valueSource: 'genoa_type',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        company_status: {
          title: 'company-status',
          key: 'company_status',
          type: 'checkbox',
          valueSource: 'company_status',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        brands: {
          title: 'brands',
          key: 'brands',
          type: 'checkbox',
          valueSource: 'brands',
          returnField: 'name',
          changeCallback: 'setKeyListValue',
          classes: { container: [] }
        },
        licenseRequired: {
          title: 'license-required',
          key: 'licenseRequired',
          type: 'radio',
          valueSource: 'licenseRequired',
          changeCallback: 'setKeyValue',
          removeCallback: 'removeFilter',
          classes: { container: [], input: [] }
        }
      },
      limits: {
        cabins: [0, 0],
        years: [0, 0],
        bathrooms: [0, 0],
        guests: [0, 0],
        length: [0, 0],
      },
      sliders: {
        cabins: [0, 0],
        years: [0, 0],
        bathrooms: [0, 0],
        guests: [0, 0],
        length: [0, 0],
      },
    }
  },
  watch: {
    'searchFilters' () {
      if (this.noLimits) {
        this.noLimits.forEach(name => this.toggleLength(name))
      }

      this.updateSelectedItemsLimits()
    },
    '$store.state.lang.currentCurrency' () {
      this.$Search.setAttributeValue('currency', this.$store.state.lang.currentCurrency)
      this.applyFilters()
    },
    'breakpoint' () {
      this.parseState()
    },
    'defOpenFilters' () {
      this.parseFiltersState()
    }
  },
  mounted () {
    this.filterKeys.forEach((key) => {
      this.openFilters[key] = false
    })
    this.$nuxt.$on('setPage', (event) => {
      this.$Search.setAttributeValue('page', event)
      this.applyFilters()
    })
    this.$nuxt.$on('searchStarting', (event) => {
      this.limits.length = [null, null]
    })

    this.$nuxt.$on('applyFilters', (data = undefined) => {
      this.applyFilters(data)
    })

    this.parseState()
    this.parseFiltersState()

    this.$nextTick(() => {
      this.updateSelectedItemsLimits()
    })
  },
  beforeDestroy () {
    this.$nuxt.$off('applyFilters')
    this.$nuxt.$off('searchStarting')
    this.$nuxt.$off('setPage')
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint'
    }),
    ...mapGetters({
      searchTerms: 'search/searchTerms'
    }),
    getFilterKeysConfig () {
      const filteredConfig = {}

      Object.keys(this.filterKeysConfig).forEach((key) => {
        if (SEARCH_OTHER_PAGES.includes(this.$route.name)) {
          if (!SEARCH_OTHER_PAGES_FILTERS_WHITELIST.includes(key)) {
            return
          }
        }

        filteredConfig[key] = this.filterKeysConfig[key]
      })

      return filteredConfig
    },
    filterKeys () {
      return Object.keys(this.getFilterKeysConfig)
    },
    hasFilters () {
      return this.searchFilters && isObject(this.searchFilters) && Object.keys(this.searchFilters).length
    },
    getFilter () {
      const result = {
        ...this?.searchFilters
      }
      const brands = this?.searchFilters?.brands || []
      const locations = this?.searchFilters?.locations || []
      const charterTypes = this?.searchFilters?.charter_types || []
      const boatTypes = this?.searchFilters?.boat_types || []
      const companyStatus = this?.searchFilters?.company_status || []

      if (Array.isArray(brands) && brands.length) {
        result.brands = [...brands].sort((a, b) => {
          return b.count - a.count
        })
      }
      if (Array.isArray(locations) && locations.length) {
        result.locations = [...locations].sort((a, b) => {
          return b.count - a.count
        })
      }
      if (Array.isArray(charterTypes) && charterTypes.length) {
        result.charter_types = [...charterTypes].sort((a, b) => {
          return b.count - a.count
        })
      }
      if (Array.isArray(boatTypes) && boatTypes.length) {
        result.boat_types = [...boatTypes].sort((a, b) => {
          return b.count - a.count
        })
      }
      if (Array.isArray(companyStatus) && companyStatus.length) {
        result.company_status = [...companyStatus].filter(c => [3, 4, '3', '4'].includes(c.key)).sort((a, b) => {
          return b.count - a.count
        })
      }

      if (['brand', 'boat-type'].includes(this.$route.name)) {
        result.brands = result.brands?.filter(q => q.count)
        result.locations = result.locations?.filter(q => q.count)
        result.charter_types = result.charter_types?.filter(q => q.count)
        result.boat_types = result.boat_types?.filter(q => q.count)
      }
      return this.filterFiltersFunction(result)
    },
    getFilters () {
      const result = {}

      this.filterKeys.forEach((filterKey) => {
        const config = this.getFilterKeysConfig[filterKey]
        const valueSource = config.valueSource || filterKey

        result[filterKey] = {
          title: this.$t(config.title),
          isOpen: this.openFilters[filterKey],
          key: config.key,
          type: config.type,
          classes: config.classes,
          changeCallback: this[config.changeCallback]
        }

        if (config.type === 'checkbox' || config.type === 'radio') {
          result[filterKey].hasValues = this.getFilter[valueSource] && this.getFilter[valueSource].length &&
            (valueSource === filterKey || this.isAlwaysOpenFilter(valueSource))
          if (config.type === 'checkbox') {
            result[filterKey].values = this.getFilter[valueSource]
            // ? dcopy(this.getFilter[valueSource])?.sort((a, b) => {
            //   a.selected = this.$Search.isFilterValueSelected(config.key, a.key || a.id)
            //   b.selected = this.$Search.isFilterValueSelected(config.key, b.key || b.id)
            //
            //   if (a.selected && !b.selected) {
            //     return -1
            //   }
            //   if (!a.selected && b.selected) {
            //     return 1
            //   }
            //   return 0
            // })
            // : this.getFilter[valueSource]

            if (!this.filterShowLimits[filterKey] && !this.noLimits.includes(filterKey)) {
              const selectedItems = result[filterKey].values?.filter(item =>
                this.$Search.isFilterValueSelected(config.key, item.key || item.id)
              ) || []
              const selectedCount = selectedItems.length

              if (selectedCount > this.filter.limit) {
                this.filterShowLimits[filterKey] = selectedCount
              } else {
                this.filterShowLimits[filterKey] = this.filter.limit
              }
            }
          }
        } else if (config.type === 'range') {
          result[filterKey].hasValues = this.hasFilterRange(valueSource) && this.isAlwaysOpenFilter(valueSource)
          result[filterKey].range = this.getFilterRange(valueSource)
          result[filterKey].values = this.getAttributeRange(valueSource)
          this.limits[filterKey] =  [result[filterKey].range.min, result[filterKey].range.max]
          const value = this.$Search.getAttributeValue(filterKey)
          this.sliders[filterKey] = [value.min, value.max]
          result[filterKey].model = `${filterKey}Range`
        } else if (config.type === 'subscribes') {
          result[filterKey].hasValues = this.getFilter[valueSource] && this.getFilter[valueSource].length && this.isAlwaysOpenFilter(valueSource)
          result[filterKey].values = this.getFilter[valueSource]
          result[filterKey].min = {
            model: this.priceStartModel,
            options: this.getPriceOptions('start'),
            placeholder: this.$t('minimum-price')
          }
          result[filterKey].max = {
            model: this.priceEndModel,
            options: this.getPriceOptions('end'),
            placeholder: this.$t('maximum-price')
          }
          result[filterKey].labelParams = ['name']
        }

        if (config.type === 'radio') {
          result[filterKey].isSelected = this.$Search.isChangedAttribute(config.key)
          result[filterKey].values = this.getFilter[valueSource]
          result[filterKey].removeCallback = this.removeFilter
          result[filterKey].removeCallbackTitle = this.$options.filters.arrayToStringJoin(this.$Search.getAttributeValueTitle(config.key))
        }

        if (config.returnField) {
          result[filterKey].returnField = config.returnField
        }
        if (config.withCount !== undefined) {
          result[filterKey].withCount = config.withCount
        }
        if (config.hasTranslation) {
          result[filterKey].hasTranslation = config.hasTranslation
        }
      })
      return result
    },
    getSelectedFilterName: app => (key) => {
      return app.$options?.filters?.arrayToStringJoin(app.$Search.getAttributeValueTitle(key))
    },
    filterShowLimits: {
      get () {
        return this.$store.state.search.filterShowLimits
      },
      set (value) {
        this.$store.commit('search/SET_FILTERS_SHOW_LIMITS', value)
      }
    },
    isAlwaysOpenFilter () {
      return (key) => {
        if (this.alwaysOpenFilters.includes('all')) {
          return true
        }
        if (Array.isArray(this.alwaysOpenFilters)) {
          return !!this.alwaysOpenFilters.includes(key)
        }
      }
    }
  },
  destroyed () {
    this.$nuxt.$off('setPage')
    this.$nuxt.$off('resetFilters')
  },
  methods: {
    self () {
      return this
    },
    toggleMenu () {
      if (this.alwaysOpen) {
        this.filter.isOpen = true
        return
      }
      this.filter.isOpen = !this.filter.isOpen
    },
    parseState () {
      if (this.breakpoint.screen.width < 1024) {
        if (this.alwaysOpen) {
          this.filter.isOpen = true
        } else {
          this.filter.isOpen = false
        }

        return
      }
      this.filter.isOpen = true
    },
    applySliderValue (filterKey) {
      this.$Search.setAttributeValue(filterKey, { min: this.sliders[filterKey][0], max: this.sliders[filterKey][1] })
      this.applyFilters()
    },
    applyFilters () {
      clearTimeout(this.request.timer)
      this.request.timer = setTimeout(() => {
        this.processRequest()
      }, 500)
    },
    async processRequest () {
      this.request.stack.loading = true
      await new Promise((resolve, reject) => {
        this.$Search.search().finally(() => {
          resolve()
        })
      })
    },
    isChangedAttribute (key) {
      return this.$Search.isChangedAttribute(key)
    },
    executeFilter () {
      this.$Search.setAttributeValue('page', 1)
      this.applyFilters()
    },
    setKeyValue (args) {
      const [key, value] = args
      this.$Search.setAttributeValue(key, value)
      this.executeFilter()
    },
    setKeyMinValue (args) {
      this.priceStartModel = args.value
      this.executeFilter()
    },
    setKeyMaxValue (args) {
      this.priceEndModel = args.value
      this.executeFilter()
    },
    setKeyListValue (args) {
      const [key, value] = args
      this.$Search.toggleAttributeValue(key, value)

      this.executeFilter()

      this.$nextTick(() => {
        this.updateSelectedItemsLimits()
      })
    },
    setBoolean (args) {
      const [key, value] = args
      this.$Search.setAttributeValue(key, !![true, 'true'].includes(value))
      this.executeFilter()
    },
    removeFilter (key, link = false) {
      if (this.isLink && link) {
        return this.$Search.getFilterUrl(key, this.$Search.getDefaultAttributeValue(key))
      } else {
        this.$Search.resetAttributeValue(key)
        this.executeFilter()
      }
    },
    toggleFilter (value) {
      if (this.alwaysOpenFilters.includes('all') || this.alwaysOpenFilters.includes(value)) {
        this.openFilters[value] = true
        return
      }
      if (Object.keys(this.openFilters).includes(value)) {
        this.openFilters[value] = !this.openFilters[value]
      }
    },
    parseFiltersState () {
      if (this.defOpenFilters) {
        if (this.defOpenFilters.includes('all')) {
          Object.keys(this.openFilters).forEach((key) => {
            this.openFilters[key] = true
          })
        } else {
          this.defOpenFilters.forEach((fName) => {
            if (this.defOpenFilters[fName]) {
              this.defOpenFilters[fName] = true
            }
          })
        }
      }
    },
    toggleLength (key, filter) {
      if (!filter && key && this.getFilters[key]) {
        filter = this.getFilters[key]
      }

      if (!filter) {
        return
      }

      const maxLength = filter?.values?.length || this.filter.limit

      const selectedItems = filter?.values?.filter(item =>
        this.$Search.isFilterValueSelected(filter.key, item.key || item.id)
      ) || []
      const selectedCount = selectedItems.length

      if (this.noLimits.includes(key) && this.filterShowLimits[key] !== this.filter.limit) {
        return
      }

      if (this.filterShowLimits[key] === this.filter.limit ||
        (selectedCount > this.filter.limit && this.filterShowLimits[key] === selectedCount)) {
        const temp = { ...this.filterShowLimits }
        temp[key] = maxLength
        this.filterShowLimits = temp
      } else {
        const temp = { ...this.filterShowLimits }

        if (selectedCount > this.filter.limit) {
          temp[key] = selectedCount
        } else {
          temp[key] = this.filter.limit
        }

        this.filterShowLimits = temp
      }
    },

    updateSelectedItemsLimits () {
      this.filterKeys.forEach((filterKey) => {
        const config = this.getFilterKeysConfig[filterKey]

        if (config.type === 'checkbox') {
          const valueSource = config.valueSource || filterKey
          const values = this.getFilter[valueSource]

          if (values && values.length) {
            const selectedItems = values.filter(item =>
              this.$Search.isFilterValueSelected(config.key, item.key || item.id)
            )
            const selectedCount = selectedItems.length

            if (this.filterShowLimits[filterKey] === this.filter.limit) {
              if (selectedCount > this.filter.limit) {
                const temp = { ...this.filterShowLimits }
                temp[filterKey] = selectedCount
                this.filterShowLimits = temp
              }
            } else if (this.filterShowLimits[filterKey] === selectedCount - 1) {
              const temp = { ...this.filterShowLimits }
              temp[filterKey] = selectedCount
              this.filterShowLimits = temp
            }
          }
        }
      })
    }
  }
}
